import styled, { css } from 'styled-components';
import SearchResult from './search-result';

const Popover = css`
	max-height: 80vh;
	overflow: scroll;
	-webkit-overflow-scrolling: touch;
	position: absolute;
	z-index: 2;
	right: 0;
	top: 100%;
	margin-top: 0.5em;
	max-width: 30em;
	box-shadow: 0 0 5px 0;
	border-radius: 2px;
	text-align: right;

	@media only screen and (min-device-width: 425px) {
		width: 75vw;
	}

	@media only screen and (min-device-width: 426px) and (max-device-width: 768px) {
		width: 55vw;
	}

	@media only screen and (min-device-width: 769px) {
		width: 30vw;
	}
`;

export default styled(SearchResult)`
  display: ${(props) => (props.show ? `block` : `none`)};
  ${Popover}

 

  .Hits {
    ul {
      list-style: none;
	  margin-left: 0;
	  background-color: black;
	  color:white
     
    }

    li.ais-Hits-item {
      margin-bottom: 0em; 
      

      a {
        color: ${({ theme }) => theme.foreground};
        

        h4 {
          margin-bottom: 0.2em;
		  font-size: 1rem;
		  color:white;
        }
      }
    }
  }

  
`;
